<template>
  <div v-if="$store.state.isGoogleApiLoaded">
    <OrderPlaceField
      :disabled="isFulfilledOrder"
      v-for="(orderPlace, index) in order.places"
      :order-place="orderPlace"
      :index="index"
      :is-last="order.places.length - 1 === index"
      :key="'opf-' + index"
      :client="order.client"
    ></OrderPlaceField>
  </div>
</template>

<script>
import OrderPlaceField from '@/components/dashboard/Delivery/OrderPlaceField'

export default {
  name: 'OrderPlaces',
  components: { OrderPlaceField },
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  computed: {
    isFulfilledOrder () {
      return this.order.state !== 'new'
    }
  }
}
</script>

<style scoped>

</style>
